class Late {
  constructor(tarRetAnt, cantidad, elementoId, elemento) {
    this.tarRetAnt = tarRetAnt;
    this.cantidad = this.formatCantidad(cantidad); // Almacena el valor formateado
    this.elementoId = elementoId;
    this.elemento = elemento;
  }

  static fromJson({ tarRetAnt, cantidad, elementoId, elemento }) {
    return new Late(tarRetAnt, cantidad, elementoId, elemento);
  }

  formatCantidad(cantidad) {
    const horas = Math.floor(cantidad / 60);
    const minutos = cantidad % 60;
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
  }
}

export default Late;
